import apiClient from "./client";
import type {
  GetMailOrganizationsParams,
  MailOrganizationsPreviewResponse,
} from "../types/mail";

export const getMailOrganizations = async (
  params: GetMailOrganizationsParams
): Promise<MailOrganizationsPreviewResponse> => {
  const { data } = await apiClient.get<MailOrganizationsPreviewResponse>(
    "/mail/organizations",
    { params }
  );
  return data;
};
